var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#94A0A7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25V2.25H9.75L12.2175 4.7175L4.7175 12.2175L2.25 9.75V15.75H8.25L5.7825 13.2825L13.2825 5.7825L15.75 8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSideArrow);
export default __webpack_public_path__ + "static/media/two-side-arrow.231c61cffb05e0a3fd2ae54b4fc29aaf.svg";
export { ForwardRef as ReactComponent };